import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { brand } from '../mock';

const FloatingCall = () => {
  return (
    <div className="fixed bottom-5 right-5 z-[80] flex flex-col items-end gap-3">
      <a
        href={`mailto:${brand.email}`}
        aria-label={`Email us at ${brand.email}`}
        className="animate-jiggle inline-flex items-center gap-2.5 bg-white text-[#262629] font-semibold px-5 py-3.5 rounded-[10px] shadow-xl shadow-black/30 hover:bg-white/85 transition-colors"
      >
        <Mail className="w-5 h-5" strokeWidth={2.5} />
        <span className="hidden sm:inline">Email us</span>
      </a>
      <a
        href={brand.phoneHref}
        aria-label={`Call us on ${brand.phone}`}
        style={{ animationDelay: '2s' }}
        className="animate-jiggle inline-flex items-center gap-2.5 bg-jaw-yellow text-[#262629] font-semibold px-5 py-3.5 rounded-[10px] shadow-xl shadow-black/30 hover:bg-[#e8660a] transition-colors"
      >
        <Phone className="w-5 h-5" strokeWidth={2.5} />
        <span className="hidden sm:inline">Call us</span>
      </a>
    </div>
  );
};

export default FloatingCall;
